// Auto-Import Reducer
import {
  GET_LINKS_BY_CAMPAIGN,
  GET_LINKS_BY_CAMPAIGN_SUCCESS,
  GET_LINKS_BY_CAMPAIGN_FAIL,
  GET_LINKS_BY_CAMPAIGN_RESET,
  GET_LINKS_BY_PROJECT,
  GET_LINKS_BY_PROJECT_SUCCESS,
  GET_LINKS_BY_PROJECT_FAIL,
  GET_LINKS_BY_PROJECT_RESET,
  GET_LINKABLE_PROJECTS,
  GET_LINKABLE_PROJECTS_SUCCESS,
  GET_LINKABLE_PROJECTS_FAIL,
  GET_LINKABLE_PROJECTS_RESET,
  SAVE_AUTO_IMPORT_LINKS,
  SAVE_AUTO_IMPORT_LINKS_SUCCESS,
  SAVE_AUTO_IMPORT_LINKS_FAIL,
  SAVE_AUTO_IMPORT_LINKS_RESET,
  FORCE_SYNC_FROM_CAMPAIGN,
  FORCE_SYNC_FROM_CAMPAIGN_SUCCESS,
  FORCE_SYNC_FROM_CAMPAIGN_FAIL,
  FORCE_SYNC_FROM_CAMPAIGN_RESET,
  FORCE_SYNC_FROM_PROJECT,
  FORCE_SYNC_FROM_PROJECT_SUCCESS,
  FORCE_SYNC_FROM_PROJECT_FAIL,
  FORCE_SYNC_FROM_PROJECT_RESET,
  GET_AUTO_SYNC_STATUS,
  GET_AUTO_SYNC_STATUS_SUCCESS,
  GET_AUTO_SYNC_STATUS_FAIL,
  GET_AUTO_SYNC_STATUS_RESET,
} from '../actions/autoImportAction';

const blank = { apiState: 'idle', data: null, message: null, errors: null, error: null };

const initialState = {
  linksByCampaign: { ...blank },
  linksByProject: { ...blank },
  linkableProjects: { ...blank },
  saveLinks: { ...blank },
  forceSyncCampaign: { ...blank },
  forceSyncProject: { ...blank },
  syncStatus: { ...blank },
};

const pendingMerge = (key) => ({ [key]: { apiState: 'loading', data: null, message: null, errors: null, error: null } });
const successMerge = (key, payload) => ({
  [key]: {
    apiState: 'success',
    data: payload?.data ?? payload?.payload ?? payload ?? null,
    message: payload?.message ?? null,
    errors: null,
    error: null,
  },
});
const failMerge = (key, payload) => ({
  [key]: {
    apiState: 'error',
    data: null,
    message: payload?.message ?? null,
    errors: payload?.errors ?? null,
    error: payload?.error ?? payload ?? null,
  },
});
const resetMerge = (key) => ({ [key]: { ...blank } });

const autoImportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LINKS_BY_CAMPAIGN:
      return { ...state, ...pendingMerge('linksByCampaign') };
    case GET_LINKS_BY_CAMPAIGN_SUCCESS:
      return { ...state, ...successMerge('linksByCampaign', action.payload) };
    case GET_LINKS_BY_CAMPAIGN_FAIL:
      return { ...state, ...failMerge('linksByCampaign', action.payload) };
    case GET_LINKS_BY_CAMPAIGN_RESET:
      return { ...state, ...resetMerge('linksByCampaign') };

    case GET_LINKS_BY_PROJECT:
      return { ...state, ...pendingMerge('linksByProject') };
    case GET_LINKS_BY_PROJECT_SUCCESS:
      return { ...state, ...successMerge('linksByProject', action.payload) };
    case GET_LINKS_BY_PROJECT_FAIL:
      return { ...state, ...failMerge('linksByProject', action.payload) };
    case GET_LINKS_BY_PROJECT_RESET:
      return { ...state, ...resetMerge('linksByProject') };

    case GET_LINKABLE_PROJECTS:
      return { ...state, ...pendingMerge('linkableProjects') };
    case GET_LINKABLE_PROJECTS_SUCCESS:
      return { ...state, ...successMerge('linkableProjects', action.payload) };
    case GET_LINKABLE_PROJECTS_FAIL:
      return { ...state, ...failMerge('linkableProjects', action.payload) };
    case GET_LINKABLE_PROJECTS_RESET:
      return { ...state, ...resetMerge('linkableProjects') };

    case SAVE_AUTO_IMPORT_LINKS:
      return { ...state, ...pendingMerge('saveLinks') };
    case SAVE_AUTO_IMPORT_LINKS_SUCCESS:
      return { ...state, ...successMerge('saveLinks', action.payload) };
    case SAVE_AUTO_IMPORT_LINKS_FAIL:
      return { ...state, ...failMerge('saveLinks', action.payload) };
    case SAVE_AUTO_IMPORT_LINKS_RESET:
      return { ...state, ...resetMerge('saveLinks') };

    case FORCE_SYNC_FROM_CAMPAIGN:
      return { ...state, ...pendingMerge('forceSyncCampaign') };
    case FORCE_SYNC_FROM_CAMPAIGN_SUCCESS:
      return { ...state, ...successMerge('forceSyncCampaign', action.payload) };
    case FORCE_SYNC_FROM_CAMPAIGN_FAIL:
      return { ...state, ...failMerge('forceSyncCampaign', action.payload) };
    case FORCE_SYNC_FROM_CAMPAIGN_RESET:
      return { ...state, ...resetMerge('forceSyncCampaign') };

    case FORCE_SYNC_FROM_PROJECT:
      return { ...state, ...pendingMerge('forceSyncProject') };
    case FORCE_SYNC_FROM_PROJECT_SUCCESS:
      return { ...state, ...successMerge('forceSyncProject', action.payload) };
    case FORCE_SYNC_FROM_PROJECT_FAIL:
      return { ...state, ...failMerge('forceSyncProject', action.payload) };
    case FORCE_SYNC_FROM_PROJECT_RESET:
      return { ...state, ...resetMerge('forceSyncProject') };

    case GET_AUTO_SYNC_STATUS:
      // keep prior data so the dot doesn't flicker during polling
      return { ...state, syncStatus: { ...state.syncStatus, apiState: 'loading' } };
    case GET_AUTO_SYNC_STATUS_SUCCESS:
      return { ...state, ...successMerge('syncStatus', action.payload) };
    case GET_AUTO_SYNC_STATUS_FAIL:
      return { ...state, ...failMerge('syncStatus', action.payload) };
    case GET_AUTO_SYNC_STATUS_RESET:
      return { ...state, ...resetMerge('syncStatus') };

    default:
      return state;
  }
};

export default autoImportReducer;
